import Category from './model';

export default Category;



// WEBPACK FOOTER //
// ./data/CoveredInClass/Category/index.js